function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.789 19.92v-4.76H8.82v-2.24h1.969v-1.708c0-1.942 1.156-3.015 2.927-3.015.848 0 1.735.151 1.735.151v1.906h-.977c-.963 0-1.263.598-1.263 1.21v1.455h2.15l-.344 2.24H13.21v4.76h4.29a1.5 1.5 0 001.5-1.5v-11a1.5 1.5 0 00-1.5-1.5h-11A1.5 1.5 0 005 7.42v11a1.5 1.5 0 001.5 1.5h4.289z",
  fill: "#0558E6",
  fillRule: "evenodd"
});

function SvgFacebookinline(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25"
  }, props), _ref);
}

export default SvgFacebookinline;